export type SamFilterState<T extends SamFilter> = {
  [TYPE in SamFilterType]?: T[];
};

export enum SamFilterType {
  /** FilterType used for default filters or filters set externally (outside the view component's sphere of influence) */
  FILTER = "FILTER",
  /** FilterType used for filters set locally inside the view component, if {@link FILTER} is used for externally set filter(s) */
  LOCAL_FILTER = "LOCAL_FILTER",
  /** FilterTypes used for marking entries (two marks possible). */
  MARK_1 = "MARK_1",
  MARK_2 = "MARK_2",
  /** FilterTypes containing the raw search string. */
  RAW_SEARCH = "RAW_SEARCH",
  /** FilterTypes containing the search pattern. */
  SEARCH = "SEARCH",
}

export type SamFilterableField = string;
export const samQuickFilter = "QUICK_FILTER";
export type SamValue = SamNativeValue | SamNativeValue[];
export type SamNativeValue = string | number | boolean;
export type SamOperator =
  | "==" | "!=" | "in" | "!in"
  | "contains" | "!contains"
  | "<" | "<=" | ">=" | ">"
  | "regex_match"
  | "between";

export interface SamFilterDef {
  field: SamFilterableField;
  operator: SamOperator;
  value: SamValue;
}

export type SamFilterSource = string;
export type SamFilterAction = "INCLUDE" | "EXCLUDE" | "INTERSECT";
export type SamFilter = SamFilterDef & {
  action: SamFilterAction;
  source: SamFilterSource;
};

// @formatter:off, because IDEA does not respect the correct setting for object spacing here
export type SamTypeCheckedFilter<CHECK extends SamFilterDef[]> =
  & { [K in keyof CHECK]: CHECK[K] }[keyof CHECK]
  & SamFilter;
